import { render, staticRenderFns } from "./HyphenInput.vue?vue&type=template&id=7b23e80a&scoped=true"
import script from "./HyphenInput.vue?vue&type=script&lang=js"
export * from "./HyphenInput.vue?vue&type=script&lang=js"
import style0 from "./HyphenInput.vue?vue&type=style&index=0&id=7b23e80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23e80a",
  null
  
)

export default component.exports